var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":"/index"}},[_c('div',{attrs:{"id":"container"}},[_c('h2',[_vm._v("Ooops")]),_vm._v(" "),_c('h3',[_vm._v("The resource you were trying to access isn't here")]),_vm._v(" "),_c('h4',[_vm._v("Click anywhere to go back to the homepage")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-742d0717","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Error.vue
// module id = VbiY
// module chunks = 1